import { EDIT_TRAVELERS } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackEditTravelers = async (context) =>
  trackBaseEvent(context, {
    eventName: EDIT_TRAVELERS,
    properties: {},
  });
